<div class="footer justify-content-center">
  <!-- <div class="context justify-content-center">
        <ul class="footer-content">
          <li><a href="#">About Sooper Dr</a> </li>
          <li><a href="#">Our Plans</a> </li>
        </ul>
        <ul class="footer-content">
            <li><a href="#">Terms &amp; Conditions</a> </li>
            <li><a href="#">Privacy Statements</a> </li>
        </ul>
        <ul class="footer-content">
          <li><a href="#">Help</a> </li>
          <li> <a href="#">Careers</a> </li>
          <li> <a href="#">Contact</a> </li>
        </ul>
      </div>
    <span>&copy;ReliableDrs Inc.</span>
  </div>-->
  <span>2020 &copy;ReliableDrs Inc. All Rights Reserved.</span>
</div>